// src/pages/dashboard/wallet-detail/shared/WalletPrivateKeyModal.tsx
import React from 'react';
import { CopyIcon } from '../../../../components/ui/Icons';
import { copyToClipboard } from './wallet-utils';
import '../../../../assets/styles/wallet-detail-button.css'; // Importamos los estilos de botones

interface WalletPrivateKeyModalProps {
  privateKeyData: string | null;
  onClose: () => void;
}

export default function WalletPrivateKeyModal({ privateKeyData, onClose }: WalletPrivateKeyModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
      <div className="bg-white p-8 rounded-xl w-[90%] max-w-[500px]">
        <h3 className="mb-5 text-xl text-center font-semibold">Private Key</h3>

        <div className="p-4 bg-gray-100 rounded-md mb-5 relative">
          {privateKeyData ? (
            <>
              <p className="text-base font-mono break-all text-center">
                {privateKeyData}
              </p>
              <button
                onClick={() => copyToClipboard(privateKeyData)}
                className="absolute top-1 right-1 bg-transparent border-none cursor-pointer p-1"
              >
                <CopyIcon size={16} color="#666" />
              </button>
            </>
          ) : (
            <p className="text-center">Loading private key...</p>
          )}
        </div>

        <div className="bg-yellow-100 text-yellow-800 p-4 rounded-md mb-5 text-sm">
          <p className="mb-2">⚠️ <strong>IMPORTANT SECURITY WARNING:</strong></p>
          <ul className="pl-5 list-disc">
            <li className="mb-1">Never share your private key with anyone.</li>
            <li className="mb-1">Anyone with your private key has full control of your wallet and funds.</li>
            <li className="mb-1">Store your private key in a secure location, preferably offline.</li>
            <li>Be aware of phishing attempts and scams trying to steal your private key.</li>
          </ul>
        </div>

        <div className="flex justify-center">
          <button
            onClick={onClose}
            className="wallet-btn wallet-btn-default"
          >
            Close
          </button>
        </div>
      </div>
    </div>

  );
}